import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PrivacyProvider } from "@/context/PrivacyContext";
import { FeatureFlagsProvider } from "@/context/FeatureFlagsContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Patrimonio from "@/pages/Patrimonio";
import Activos from "@/pages/Activos";
import Ingresos from "@/pages/Ingresos";
import Gastos from "@/pages/Gastos";
import Compromisos from "@/pages/Compromisos";
import Financiaciones from "@/pages/Financiaciones";
import Pagos from "@/pages/Pagos";
import Proyecciones from "@/pages/Proyecciones";
import Familia from "@/pages/Familia";
import Mantenimiento from "@/pages/Mantenimiento";
import Analitica from "@/pages/Analitica";
import Copiloto from "@/pages/Copiloto";
import Seguros from "@/pages/Seguros";
import Datos from "@/pages/Datos";
import Perfil from "@/pages/Perfil";
import Planes from "@/pages/Planes";
import Cripto from "@/pages/Cripto";
import Notificaciones from "@/pages/Notificaciones";
import Renovaciones from "@/pages/Renovaciones";
import Matriz from "@/pages/Matriz";
import EconomiaMiembro from "@/pages/EconomiaMiembro";
import Tesoreria from "@/pages/Tesoreria";
import LibertadFinanciera from "@/pages/LibertadFinanciera";
import Inversiones from "@/pages/Inversiones";
import GastosZombie from "@/pages/GastosZombie";
import ScmePanel from "@/pages/ScmePanel";
import Restablecer, { Verificar } from "@/pages/Restablecer";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-sm text-muted-foreground">Cargando…</div>
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PrivacyProvider>
          <FeatureFlagsProvider>
            <BrowserRouter>
              <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/planes" element={<Planes />} />
              <Route path="/registro" element={<Navigate to="/planes" replace />} />
              <Route path="/register" element={<Navigate to="/planes" replace />} />
              <Route path="/signup" element={<Navigate to="/planes" replace />} />
              <Route path="/restablecer" element={<Restablecer />} />
              <Route path="/verificar" element={<Verificar />} />
              <Route path="/perfil" element={<Protected><Perfil /></Protected>} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/patrimonio" element={<Protected><Patrimonio /></Protected>} />
              <Route path="/activos" element={<Protected><Activos /></Protected>} />
              <Route path="/ingresos" element={<Protected><Ingresos /></Protected>} />
              <Route path="/gastos" element={<Protected><Gastos /></Protected>} />
              <Route path="/compromisos" element={<Protected><Compromisos /></Protected>} />
              <Route path="/recurrentes" element={<Navigate to="/compromisos" replace />} />
              <Route path="/financiaciones" element={<Protected><Financiaciones /></Protected>} />
              <Route path="/obligaciones" element={<Protected><Financiaciones /></Protected>} />
              <Route path="/libertad-financiera" element={<Protected><LibertadFinanciera /></Protected>} />
              <Route path="/gastos-zombie" element={<Protected><GastosZombie /></Protected>} />
              <Route path="/scme" element={<Protected><ScmePanel /></Protected>} />
              <Route path="/inversiones" element={<Protected><Inversiones /></Protected>} />
              <Route path="/seguros" element={<Protected><Seguros /></Protected>} />
              <Route path="/pagos" element={<Protected><Pagos /></Protected>} />
              <Route path="/proyecciones" element={<Protected><Proyecciones /></Protected>} />
              <Route path="/familia" element={<Protected><Familia /></Protected>} />
              <Route path="/categorias" element={<Navigate to="/listado-valores" replace />} />
              <Route path="/mantenimiento" element={<Protected><Mantenimiento /></Protected>} />
              <Route path="/listado-valores" element={<Protected><Mantenimiento /></Protected>} />
              <Route path="/analitica" element={<Protected><Analitica /></Protected>} />
              <Route path="/copiloto" element={<Protected><Copiloto /></Protected>} />
              <Route path="/cripto" element={<Protected><Cripto /></Protected>} />
              <Route path="/activos-financieros" element={<Navigate to="/cripto" replace />} />
              <Route path="/notificaciones" element={<Protected><Notificaciones /></Protected>} />
              <Route path="/renovaciones" element={<Protected><Renovaciones /></Protected>} />
              <Route path="/matriz" element={<Protected><Matriz /></Protected>} />
              <Route path="/economia-miembro" element={<Protected><EconomiaMiembro /></Protected>} />
              <Route path="/tesoreria" element={<Protected><Tesoreria /></Protected>} />
              <Route path="/datos" element={<Protected><Datos /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
          </FeatureFlagsProvider>
          <Toaster position="top-center" richColors />
        </PrivacyProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
